import React from 'react';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { useTheme } from '../ThemeContext';
import {
  TRANSPARENT_WHITE_23,
  TEXT_PRIMARY_DARK,
  DARK_THEME_PAPER,
  TEXT_PRIMARY_LIGHT,
  LIGHT_THEME_PAPER,
  PRIMARY_PINK,
} from '../constants';

function ThemedDateTimePicker({ darkMode, sx, ...props }) {
  const { darkMode: themeDarkMode } = useTheme();
  const isDarkMode = darkMode !== undefined ? darkMode : themeDarkMode;
  
  return (
    <DateTimePicker
      {...props}
      slotProps={{
        textField: {
          variant: "outlined",
          fullWidth: true,
          sx: {
            ...sx,
            "& .MuiInputBase-input": {
              padding: "8.5px 0px 8.5px 14px",
              width: "100%",
              color: isDarkMode ? TEXT_PRIMARY_DARK + " !important" : TEXT_PRIMARY_LIGHT + " !important",
            },
            "& .MuiOutlinedInput-root": {
              backgroundColor: isDarkMode
                ? DARK_THEME_PAPER + " !important"
                : LIGHT_THEME_PAPER,
              "& fieldset": {
                borderColor: isDarkMode ? TRANSPARENT_WHITE_23 + " !important" : "rgba(0, 0, 0, 0.23) !important",
              },
              "&:hover fieldset": {
                borderColor: isDarkMode ? "rgba(255, 255, 255, 0.5) !important" : "rgba(0, 0, 0, 0.5) !important",
              },
              "&.Mui-focused fieldset": {
                borderColor: PRIMARY_PINK + " !important",
              },
            },
            "& .MuiInputLabel-root": {
              color: isDarkMode ? TEXT_PRIMARY_DARK + " !important" : TEXT_PRIMARY_LIGHT + " !important",
              "&.Mui-focused": {
                color: PRIMARY_PINK + " !important",
              },
            },
            "& .MuiSvgIcon-root": {
              color: isDarkMode ? TEXT_PRIMARY_DARK + " !important" : TEXT_PRIMARY_LIGHT + " !important",
            },
            "& .MuiIconButton-root": {
              color: isDarkMode ? TEXT_PRIMARY_DARK + " !important" : TEXT_PRIMARY_LIGHT + " !important",
            },
            width: "100%",
          }
        }
      }}
    />
  );
}

export default ThemedDateTimePicker;
